<ng-container *notInProductCode="productCode.Partners">
  <div class="full-page-container">
    <fgb-page-header [pageTitle]="'trivia.play.title'" [showFooter]="false" [backButtonLink]="'/games'"></fgb-page-header>
    <div class="game-layout-banner pb-0">
      <div class="container" fgbAnimateOnScroll>
        <div class="game-banner-img mt-lg-0">
          <img src="assets/images/games/TriviaBanner.jpg" alt="" />
        </div>
        <div class="pt-lg-3 pb-lg-0 mb-lg-0 mb-2 pt-1">
          <fgb-route-nav>
            <a
              class="nav-item"
              [routerLink]="['/games/trivia']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <label>{{ 'quiz.nav.play' | translate }}</label>
            </a>
            <a
              class="nav-item"
              [routerLink]="['/games/trivia/leaderboard']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <label>{{ 'quiz.nav.leaderboard' | translate }}</label>
            </a>
          </fgb-route-nav>
        </div>
      </div>
    </div>

    <div class="mobile-content-wrapper mt-lg-0 mt-1">
      <router-outlet></router-outlet>
    </div>
  </div>
</ng-container>

<ng-container *inProductCode="productCode.Partners">
  <fgb-not-found-page></fgb-not-found-page>
</ng-container>
